// Categorias das fotos de vistoria (cta.inspection_evidence.evidence_type, MIG/069).
// Mesmo catalogo do servidor (cta_catalogs.EVIDENCE_CATEGORIES); um teste do
// backend falha se os dois divergirem.

export type PhotoCategoryGroup = "EXEMPLAR" | "LOCAL" | "OUTRO";

export interface PhotoCategory {
  code: string;
  group: PhotoCategoryGroup;
  label: string;
}

export const PHOTO_CATEGORY_GROUPS: { code: PhotoCategoryGroup; label: string; icon: string }[] = [
  { code: "EXEMPLAR", label: "Exemplar", icon: "ri-plant-line" },
  { code: "LOCAL", label: "Local", icon: "ri-road-map-line" },
  { code: "OUTRO", label: "Outro", icon: "ri-more-line" },
];

export const PHOTO_CATEGORIES: PhotoCategory[] = [
  { code: "GENERAL_TREE", group: "EXEMPLAR", label: "Vista geral" },
  { code: "CROWN", group: "EXEMPLAR", label: "Copa" },
  { code: "TRUNK", group: "EXEMPLAR", label: "Tronco" },
  { code: "ROOT_COLLAR", group: "EXEMPLAR", label: "Colo" },
  { code: "ROOTS", group: "EXEMPLAR", label: "Raízes" },
  { code: "DEFECT", group: "EXEMPLAR", label: "Defeito ou lesão" },
  { code: "PEST_DISEASE", group: "EXEMPLAR", label: "Praga ou doença" },
  { code: "LEAVES_FLOWERS_FRUITS", group: "EXEMPLAR", label: "Folhas, flores ou frutos" },
  { code: "TAG_PLATE", group: "EXEMPLAR", label: "Plaqueta ou QR Code" },
  { code: "INTERVENTION", group: "EXEMPLAR", label: "Intervenção realizada" },
  { code: "SIDEWALK", group: "LOCAL", label: "Calçada ou passeio" },
  { code: "POWER_GRID", group: "LOCAL", label: "Fiação ou rede elétrica" },
  { code: "POLE_LIGHTING", group: "LOCAL", label: "Poste ou iluminação" },
  { code: "BUILDING_WALL", group: "LOCAL", label: "Edificação ou muro" },
  { code: "ROAD_TRAFFIC", group: "LOCAL", label: "Via ou trânsito" },
  { code: "URBAN_CONFLICT", group: "LOCAL", label: "Interferência urbana" },
  { code: "RISK_TARGET", group: "LOCAL", label: "Alvo de risco" },
  { code: "PANORAMIC", group: "LOCAL", label: "Entorno (panorâmica)" },
  { code: "OTHER", group: "OUTRO", label: "Outro" },
];

const BY_CODE = new Map(PHOTO_CATEGORIES.map((c) => [c.code, c]));

export const photoCategory = (code: string | null | undefined): PhotoCategory | undefined =>
  code ? BY_CODE.get(code) : undefined;

/** Rotulo da categoria; foto sem categoria aparece como tal, nunca como "Outro". */
export const photoCategoryLabel = (code: string | null | undefined): string =>
  photoCategory(code)?.label ?? (code ? code : "Sem categoria");

export const photoGroupLabel = (code: string | null | undefined): string | null => {
  const group = photoCategory(code)?.group;
  return group ? PHOTO_CATEGORY_GROUPS.find((g) => g.code === group)!.label : null;
};

/** Categorias agrupadas, na ordem do catalogo, para selects com <optgroup>. */
export const PHOTO_CATEGORIES_BY_GROUP = PHOTO_CATEGORY_GROUPS.map((g) => ({
  ...g,
  categories: PHOTO_CATEGORIES.filter((c) => c.group === g.code),
}));
